var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06 6.504a.991.991 0 0 1-.706-.29l-3.981-4a1.004 1.004 0 0 1 0-1.42.999.999 0 0 1 1.413 0l3.274 3.31L8.345.924A.996.996 0 0 1 9.468.67a.995.995 0 0 1 .61.981 1.004 1.004 0 0 1-.36.713l-3.98 3.86a.993.993 0 0 1-.678.28Z",
    fill: "#fff"
  })));
};

export default SvgArrowBottom;